import api from './api';

const CashBookService = {

  // Create Cash In (Credit)
  createCashIn: async (data) => {
    const response = await api.post('/api/cashbook/cashin', data);
    return response.data;
  },

  // Create Cash Out (Debit)
  createCashOut: async (data) => {
    const response = await api.post('/api/cashbook/cashout', data);
    return response.data;
  },

  // Get All Cashbook Records
  getCashBook: async () => {
    const response = await api.get('/api/cashbook');
    return response.data; // { transactions: [...] }
  }
};

export default CashBookService;
